module.exports = __webpack_public_path__ + "static/media/components.33979a04.svg";